import { render, staticRenderFns } from "./NotificationGDPR.vue?vue&type=template&id=50b540c5&"
import script from "./NotificationGDPR.vue?vue&type=script&lang=ts&"
export * from "./NotificationGDPR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports